import React from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Download from "../../../../../../assets/svg/icons/common/Download";
import InfoInCircle from "../../../../../../../../images/v2/InfoInCircle.png";
import BlockInCircle from "../../../../../../../../images/v2/BlockInCircle.png";
import FileInCircle from "../../../../../../../../images/v2/FileInCircle.png";
import MailInCircle from "../../../../../../../../images/v2/MailInCircle.png";
import FaxInCircle from "../../../../../../../../images/v2/FaxInCircle.png";

function Index() {
  return (
    <div>
      <div className={style.rebuttal_process}>
        <div className={style.header}>
          <h5>Rebuttal Process</h5>
          <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF">
            <Download color="#FFF" />
            <span>Download Template</span>
          </ButtonIcon>
        </div>

        <p className={style.paragraph}>
          When Electronic Merchant Systems receives a chargeback, which results
          in a debit to your account.{" "}
          <strong>Do not issue a credit to the cardholder by any means.</strong>
        </p>

        <div className={style.alert_info}>
          <div className={style.alert_icon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.75 4.5C7.89834 4.5 8.04334 4.54399 8.16668 4.6264C8.29002 4.70881 8.38615 4.82594 8.44291 4.96299C8.49968 5.10003 8.51453 5.25083 8.48559 5.39632C8.45665 5.5418 8.38522 5.67544 8.28033 5.78033C8.17544 5.88522 8.04181 5.95665 7.89632 5.98559C7.75083 6.01453 7.60003 5.99968 7.46299 5.94291C7.32595 5.88614 7.20881 5.79001 7.1264 5.66668C7.04399 5.54334 7 5.39834 7 5.25C7 5.05109 7.07902 4.86032 7.21967 4.71967C7.36032 4.57902 7.55109 4.5 7.75 4.5ZM8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94732 10.7402 9 10.8674 9 11C9 11.1326 8.94732 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5Z"
                fill="#626168"
              />
            </svg>
          </div>
          <p className={style.alert_text}>
            Please note that a chargeback dispute reason code may contain
            additional documentation. Please contact the Chargeback Unit to
            retrieve a copy of a dispute if needed.
          </p>
        </div>

        <p className={style.paragraph}>
          If you wish to dispute a chargeback, please provide any rebuttal
          documentation that may support your position. This might include a
          legible copy of the original credit card transaction receipt, internal
          invoice, job proposal, subsequent refund that may have been processed
          or any documentation related to the transaction in question. You may
          also include a descriptive letter of events to support your position.
        </p>

        <div className={style.alert_danger}>
          <div className={style.alert_icon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.8007 11.7557L9.33505 2.26379C9.19847 2.03124 9.00348 1.83843 8.76942 1.70445C8.53537 1.57048 8.27036 1.5 8.00067 1.5C7.73098 1.5 7.46597 1.57048 7.23192 1.70445C6.99786 1.83843 6.80288 2.03124 6.6663 2.26379L1.20067 11.7557C1.06926 11.9806 1 12.2364 1 12.4969C1 12.7574 1.06926 13.0132 1.20067 13.2382C1.3355 13.4721 1.53015 13.666 1.76465 13.7999C1.99914 13.9338 2.26504 14.0028 2.53505 14H13.4663C13.7361 14.0026 14.0017 13.9334 14.236 13.7996C14.4702 13.6657 14.6647 13.4719 14.7994 13.2382C14.931 13.0134 15.0005 12.7576 15.0007 12.4971C15.0009 12.2366 14.9319 11.9807 14.8007 11.7557ZM7.50067 6.50004C7.50067 6.36743 7.55335 6.24026 7.64712 6.14649C7.74089 6.05272 7.86806 6.00004 8.00067 6.00004C8.13328 6.00004 8.26046 6.05272 8.35422 6.14649C8.44799 6.24026 8.50067 6.36743 8.50067 6.50004V9.00004C8.50067 9.13265 8.44799 9.25983 8.35422 9.35359C8.26046 9.44736 8.13328 9.50004 8.00067 9.50004C7.86806 9.50004 7.74089 9.44736 7.64712 9.35359C7.55335 9.25983 7.50067 9.13265 7.50067 9.00004V6.50004ZM8.00067 12C7.85233 12 7.70733 11.9561 7.58399 11.8736C7.46066 11.7912 7.36453 11.6741 7.30776 11.5371C7.251 11.4 7.23614 11.2492 7.26508 11.1037C7.29402 10.9582 7.36545 10.8246 7.47034 10.7197C7.57523 10.6148 7.70887 10.5434 7.85435 10.5145C7.99984 10.4855 8.15064 10.5004 8.28768 10.5571C8.42473 10.6139 8.54186 10.71 8.62427 10.8334C8.70668 10.9567 8.75067 11.1017 8.75067 11.25C8.75067 11.449 8.67165 11.6397 8.531 11.7804C8.39035 11.921 8.19958 12 8.00067 12Z"
                fill="#E03B24"
              />
            </svg>
          </div>
          <p className={style.alert_text}>
            DO NOT provide full card numbers in any part of your documentation.
          </p>
        </div>

        <div className={style.alert_list}>
          <h5 className={style.heading}>
            Please keep the following key points in mind when considering any
            rebuttal:
          </h5>

          <div className={style.alert_item}>
            <img src={InfoInCircle} />
            <p className={style.paragraph}>
              If the chargeback reason is for{" "}
              <strong>“Requested trans info/receipt not rcvd”</strong> or this
              is the second time that you are being debited for this chargeback,
              you have no further recourse.
            </p>
          </div>

          <div className={style.alert_item}>
            <img src={BlockInCircle} />
            <p className={style.paragraph}>
              If the chargeback reason is{" "}
              <strong>“Duplicate Processing”</strong>, two separate credit card
              receipts must be provided.
            </p>
          </div>

          <div className={style.alert_item}>
            <img src={FileInCircle} />
            <p className={style.paragraph}>
              Be sure to always address the nature of the dispute and submit
              documentation to remedy the chargeback reason code.
            </p>
          </div>
        </div>

        <div className={style.alert_info}>
          <div className={style.alert_icon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.75 4.5C7.89834 4.5 8.04334 4.54399 8.16668 4.6264C8.29002 4.70881 8.38615 4.82594 8.44291 4.96299C8.49968 5.10003 8.51453 5.25083 8.48559 5.39632C8.45665 5.5418 8.38522 5.67544 8.28033 5.78033C8.17544 5.88522 8.04181 5.95665 7.89632 5.98559C7.75083 6.01453 7.60003 5.99968 7.46299 5.94291C7.32595 5.88614 7.20881 5.79001 7.1264 5.66668C7.04399 5.54334 7 5.39834 7 5.25C7 5.05109 7.07902 4.86032 7.21967 4.71967C7.36032 4.57902 7.55109 4.5 7.75 4.5ZM8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94732 10.7402 9 10.8674 9 11C9 11.1326 8.94732 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5Z"
                fill="#626168"
              />
            </svg>
          </div>
          <p className={style.alert_text}>
            When preparing and submitting your response to a chargeback dispute
            or retrieval request, please note that MasterCard has implemented a
            Chargeback Excessive Page Fee. Below are the page limits for
            MasterCard rebuttal responses. If the rebuttal exceeds the listed
            pages, MasterCard will impose a $1.00 per-page rate for all pages.
            <ul className={style.unordered_list}>
              <li>
                Chargeback – To not incur the $1.00 per-page fee, rebuttals must
                be 19 pages or less.
              </li>
              <li>
                Retrieval – To not incur the $1.00 per-page fee, rebuttals must
                be 3 pages or less.
              </li>
            </ul>
          </p>
        </div>

        <p className={style.paragraph}>
          Please return any rebuttal as soon as possible to preserve your
          chargeback rights. To allow for weekends and processing time at
          Electronic Merchant Systems, MasterCard, Visa, Discover and American
          Express, your dispute must be received no later than 20 days from the
          chargeback date indicated.
        </p>

        <div className={style.supporting_document}>
          <h5 className={style.heading}>
            Send your rebuttal and any supporting documentation:
          </h5>

          <div className={style.supporting_document_body}>
            <div className={style.supporting_document_body_left}>
              <div className={style.supporting_document_body_heading}>
                <img src={MailInCircle} />
                <h5>Mail: Electronic Merchant Systems</h5>
              </div>
              <p className={style.address}>
                Attn: Chargeback Unit, 250 W Huron Road, Suite 400, Cleveland,
                Ohio 44113Phone: (800) 726-2117 (press 6, then 2)
              </p>
            </div>

            <div className={style.supporting_document_body_right}>
              <div className={style.supporting_document_body_heading}>
                <img src={FaxInCircle} />
                <h5>Fax</h5>
              </div>
              <p className={style.address}>(216) 654-0273</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
